import React, { useCallback, useEffect } from 'react'
import { Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import AutocompleteField from '../../../../FormControl/input/AutocompleteField'
import { getLearningContinuum } from '../../../../../services/learning-continuum/learning-continuum.service'
import { useParams } from 'react-router-dom'

const FormLcElements = ({ onChangeAlert }) => {
  const { curriculumId } = useParams();

  const formData = useSelector((state) => state?.lc?.form?.lcElements || {})
  const formDataCurriculumElements = useSelector((state) => state?.lc?.form?.curriculumElements || {})

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const [isLoading, setIsLoading] = React.useState(true)
  const [options, setOptions] = React.useState({})
  const [form, setInputForm] = React.useState(formData)
  const [errors, setInputErrors] = React.useState({})

  if (!currentCurriculum || !currentCurriculum?.lcElements?.children) return <></>

  const onChange = (name, value) => {
    const formData = { ...form, [name]: value.value }
    setInputForm({ ...form, ...formData })
    setInputErrors({ ...errors, [name]: null })
    onChangeAlert('lcElements', formData)
  }

  const onLoad = useCallback(async () => {
    try {
      const filterData = {
        curriculumElements: formDataCurriculumElements,
      }
      const response = await getLearningContinuum(curriculumId, filterData)
      if (!response?.data && response?.error) {
        setInputErrors(response.error.message || 'An error ocurred')
      } else {
        let data = {}
        currentCurriculum?.lcElements?.children.forEach((item) => {
          data[item._id] = []
          response.data.forEach((element) => {
            const value = element.lcElements[item._id];
            const find = data[item._id].find((op) => op.value === value)
            if (!find) {
              data[item._id].push({
                value: element.lcElements[item._id],
                label: element.lcElements[item._id]
              })
            }
          })
        })
        setOptions(data)
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setInputErrors(message)
    } finally {
      setIsLoading(false)
    }
  }, [curriculumId, formDataCurriculumElements])


  useEffect(() => {
    onLoad()
  }, [onLoad])

  return (
    <Grid container spacing={2}>
      {currentCurriculum?.lcElements?.children
        .sort((a, b) => a.position - b.position)
        .map((item) => (
        <React.Fragment key={item._id}>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              {item?.name}
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <AutocompleteField
              id={`${item?._id}`}
              name={item?._id}     
              className='capitalize'
              error={errors[item?._id]}
              helperText={errors[item?._id]}                    
              value={form[item?._id]}
              loading={isLoading}
              options={options[item?._id] || []} 
              multiline={true}
              optionAdd={true}
              onChange={(value) => onChange(item?._id, value)}      
            />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  )
}

export default FormLcElements